import React, { useRef, useState } from 'react';
import * as htmlToImage from 'html-to-image';

/**
 * Gallery device shell. The surface colour is inherited from the mounted
 * screen so dark screens never sit on a light canvas while they render.
 */
export function PhoneFrame({
  children,
  title,
  dark = false
}: {
  children: React.ReactNode;
  title?: string;
  dark?: boolean;
}) {
  const surface = dark ? 'bg-[#061827]' : 'bg-brand-cloud';
  const frameRef = useRef<HTMLDivElement>(null);
  const [downloading, setDownloading] = useState(false);
  const downloadImage = async () => {
    if (!frameRef.current || downloading) return;
    try {
      setDownloading(true);
      const dataUrl = await htmlToImage.toPng(frameRef.current, {
        cacheBust: true,
        pixelRatio: 2
      });
      const link = document.createElement('a');
      link.download = `${title ? title.replace(/[^a-z0-9]/gi, '-').toLowerCase() : 've-bank-screen'}.png`;
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error('Failed to download image', err);
    } finally {
      setDownloading(false);
    }
  };
  return <div className="flex w-full max-w-[390px] flex-col items-center gap-4" data-id="element-131" data-mp="3461j5wjidbel">
      {title && <div className="flex w-full items-center justify-between px-4" data-id="element-132" data-mp="2z6yb0388ep2e">
          <h2 className="text-sm font-extrabold tracking-tight text-brand-navy" data-id="element-133" data-mp="2z781rt13p095">{title}</h2>
          <button onClick={downloadImage} disabled={downloading} className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-brand-cobalt shadow-sm transition-colors hover:bg-brand-cobalt hover:text-white disabled:opacity-50" aria-label={`Download ${title} as image`} title={`Download ${title}`} data-id="element-134" data-mp="2v77owctngx47">
            {downloading ? <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-135" data-mp="3dy76uu2q96nz"><path d="M21 12a9 9 0 1 1-6.219-8.56" data-id="element-136" data-mp="22fnyo8ymyisp" /></svg> : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-137" data-mp="23xcxla7lpds1"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-id="element-138" data-mp="28wfsw2xs45mt" /><polyline points="7 10 12 15 17 10" data-id="element-139" data-mp="1uxgave4ruozm" /><line x1="12" x2="12" y1="15" y2="3" data-id="element-140" data-mp="1uwequk5s2s5r" /></svg>}
          </button>
        </div>}
      <div ref={frameRef} className={`relative flex aspect-[390/844] w-full flex-col overflow-hidden rounded-[42px] border-[7px] border-[#04111d] shadow-[0_35px_90px_-35px_rgba(6,24,39,.65)] ${surface}`} data-id="element-141" data-mp="1yx70vfmh5133">
        <div className="pointer-events-none absolute inset-x-0 top-0 z-50 flex h-7 justify-center" data-id="element-142" data-mp="1pzej84ta5hcj">
          <div className="h-[29px] w-[122px] rounded-b-[18px] bg-[#04111d]" data-id="element-143" data-mp="1bb0hjx7lnyxk" />
        </div>
        <div className={`pointer-events-none absolute inset-x-0 top-0 z-40 flex h-11 items-center justify-between px-6 text-[13px] font-extrabold ${dark ? 'text-white' : 'text-brand-navy'}`} data-id="element-144" data-mp="1g8tlejlfkguo">
          <span data-id="element-145" data-mp="1772j7oq3ms5k">9:41</span>
          <span className="tracking-[.2em]" data-id="element-146" data-mp="179ot3v0gpjqy">●◒▰</span>
        </div>
        <div className={`phone-scroll relative h-full w-full flex-1 overflow-y-auto ${surface}`} data-id="element-147" data-mp="nmlk06oynokf">{children}</div>
      </div>
    </div>;
}